import type { AffiliateReferral } from '@wlb/shared/api/affiliate/affiliateTypes';

const CURRENCY_FORMAT = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'USD',
});

const COUNT_FORMAT = new Intl.NumberFormat();

const DATE_FORMAT = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });

export const formatAffiliateCurrency = (value: number): string =>
  CURRENCY_FORMAT.format(Number.isFinite(value) ? value : 0);

export const formatAffiliateCount = (value: number): string =>
  COUNT_FORMAT.format(Number.isFinite(value) ? value : 0);

/** `''` for an absent or unparseable instant, so a caller can fall back. */
export const formatAffiliateDate = (value: string): string => {
  if (!value) return '';
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? '' : DATE_FORMAT.format(parsed);
};

/**
 * Initials for a referred member.
 *
 * The API masks identity in the affiliate's own view — `firstName`/`lastName`
 * arrive as a single letter and `userName` as `K***` — so this deliberately
 * reads no further than the first character of each. It is the display for both
 * views: an operator sees the real name beside the avatar, and the initials are
 * all the portal is ever given.
 */
export const affiliateReferralInitials = (referral: AffiliateReferral): string => {
  const letters = [referral.firstName, referral.lastName]
    .map(part => part.trim().charAt(0))
    .filter(Boolean)
    .join('');
  if (letters) return letters.toUpperCase();
  const fromUserName = referral.userName.trim().charAt(0);
  return fromUserName ? fromUserName.toUpperCase() : '';
};
